import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import TextField from "material-ui/TextField";
import Slider from "material-ui/Slider";
import RemoveCircle from "material-ui/svg-icons/content/remove-circle";

import Chip from "material-ui/Chip";
import DateField from "components/Form/DateField";

import {
  UPDATE_FILTER_MEDIAGROUPS,
  UPDATE_FILTER_SEGMENTS,
  UPDATE_FILTER_CATEGORIES,
  UPDATE_FILTER_TARGETS,
  UPDATE_FILTER_SEARCH,
  UPDATE_FILTER_AGE,
  UPDATE_FILTER_GENDER,
  UPDATE_FILTER_REACH
} from "data/filters/types";
import { brands, mediagroups, segments, categories } from "data/actions";
import { TOGGLE_RIGHT } from "data/menus/types";
import BrandCard from "components/Brand/BrandCard";
import BrandRow from "components/Brand/BrandRow";
import BrandsFilter from "./BrandsFilter";
import { Page, PageBlock, PageSection } from "components/Page";
import ChipField from "components/Form/ChipField";
import Label from "components/Form/Label";
import * as os from "osutil";

class BrandsPage extends Component {
  state = {
    selected_segments: [],
    selected_categories: [],
    selected_mediagroups: [],
    selected_targets: [],
    selected_gender: NaN,
    selected_age: NaN,
    selected_reach: NaN
  };

  static contextTypes = {
    router: PropTypes.object
  };

  target = [{ key: "female", name: "Kvinna" }, { key: "male", name: "Man" }];

  componentWillMount() {
    this.props.actions.fetchBrands();
    this.props.actions.fetchMediagroups();
    this.props.actions.fetchSegments();
    this.props.actions.fetchCategories();
  }

  renderBrands() {
    return _.map(this.props.brands, (brand, key) => {
      if (brand.disabled) {
        return null;
      }

      if (this.props.filters) {
        const _search = this.props.filters[UPDATE_FILTER_SEARCH];
        if (_search && _search.length > 0) {          
          if (brand.name.toLowerCase().indexOf(_search.toLowerCase()) === -1) {
            return null;
          }
        }

        const _mediagroups = this.props.filters[UPDATE_FILTER_MEDIAGROUPS];
        if (_mediagroups && _mediagroups.length > 0) {
          var match = _mediagroups.filter((m, key) => {
            return brand.mediagroupid == m.key;
          });
          if (match.length == 0) {
            return null;
          }
        }

        const _categories = this.props.filters[UPDATE_FILTER_CATEGORIES];
        if (_categories && _categories.length > 0) {
          if (!brand.categories) {
            return null;
          }
          var match = _categories.filter((m, key) => {
            return (
              _.filter(brand.categories, (mc, kc) => mc.categoryid == m.key)
                .length > 0
            );
          });
          if (match.length < _categories.length) {
            return null;
          }
        }

        const _segments = this.props.filters[UPDATE_FILTER_SEGMENTS];
        if (_segments && _segments.length > 0) {
          if (!brand.segments) {
            return null;
          }
          var match = _segments.filter((m, key) => {
            return typeof brand.segments[m.key] != "undefined";
          });
          if (match.length < _segments.length) {
            return null;
          }
        }

        const _targets = this.props.filters[UPDATE_FILTER_TARGETS];
        if (_targets && _targets.length > 0) {
          var active = false;
          var femalefilter = _targets.filter(t => t.key == "female");
          if (femalefilter.length > 0 && brand.genderfemale > 50) {
            active = true;
          }
          var malefilter = _targets.filter(t => t.key == "male");
          if (malefilter.length > 0 && brand.gendermale > 50) {
            active = true;
          }
          if (!active) {
            return null;
          }
        }

        const _reach = this.props.filters[UPDATE_FILTER_REACH];
        if (_reach) {
          var v = Math.pow(10, _reach);
          if (!brand.reach || brand.reach < v) {
            return null;
          }
        }

        const _age = this.props.filters[UPDATE_FILTER_AGE];
        if (_age !== NaN) {
          if (_age) {
            if (!brand.agemin || (brand.agemin > _age || brand.agemax < _age)) {
              return null;
            }
          }
        }

        const _gender = this.props.filters[UPDATE_FILTER_GENDER];
        if (_gender !== NaN) {
          if (_gender < 50) {
            if (!brand.gendermale || brand.gendermale < 100 - _gender) {
              return null;
            }
          }
          if (_gender >= 50) {
            if (!brand.genderfemale || brand.genderfemale < _gender) {
              return null;
            }
          }
        }
      }

      var mg = brand.mediagroupid
        ? this.props.mediagroups[brand.mediagroupid]
        : {};
      return (
        <BrandRow
          key={brand.key}
          id={brand.key}
          mediagroup={mg}
          brand={brand}
        />
      );
      return (
        <BrandCard
          key={brand.key}
          id={brand.key}
          mediagroup={mg}
          brand={brand}
        />
      );
    });
  }

  render() {
    return [
      <BrandsFilter key="filter" />
      ,
      <header id="title" key="brand_hero">
        <div className="titleleft">
        Mediebokaren
      </div>
      <div className="titleright">
          Medier
        </div>
  </header>,
      <Page key="brands" ready={this.props.pending} className="">

            <div className="Page_Row">{this.renderBrands()}</div>

      </Page>
    ];
  }
}

function mapStateToProps(state) {
  if (
    !state.mediagroups.list.data ||
    !state.brands.list.data ||
    !state.segments.list.data
  )
  {
    return {};
  }

  var segments = os.tree_to_array(state.segments.list.data);
  var categories = os.tree_to_array(state.categories.list.data);
  var mediagroupsfilter = os.tree_to_array(state.mediagroups.list.data);

  var brands = _.values(os.add_key(state.brands.list.data));
  var sorted = brands.sort((a, b) => {
    if (a.priority || b.priority) {
      var v = 0;
      if (!a.priority) v = 1;
      else if (!b.priority) v = -1;
      else {
        v = a.priority == b.priority ? 0 : a.priority < b.priority ? -1 : 1;
      }
      return v;
    }
    return a.name.localeCompare(b.name);
  });
  return {
    brands,
    filters: state.filters,
    segments: segments,
    categories: categories,
    mediagroups: state.mediagroups.list.data,
    mediagroupsfilter: mediagroupsfilter,
    pending: state.mediagroups.list.data,
    selected_segments: [],
  };
}

const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators(
      { ...brands, ...mediagroups, ...segments, ...categories },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatch)(BrandsPage);



// WEBPACK FOOTER //
// ./src/pages/brands/BrandsPage.jsx